import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, InputDate } from "../../controls";
import { Form } from "../../layout";
import { API, actions, endpoints } from "../../api/api";
import { ToFormData } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const UnfreezeForm = (props) => {
  const { setAlert, setShowForm, member, setMembers, freezeDtls, setTblData } =
    props;
  const { t } = useTranslation();
  const [value, setValue] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (freezeDtls) setData(freezeDtls);
    else if (member) {
      API(endpoints.Freeze + actions.GetByMember).getById(member.id, (res) => {
        res && res.status === 200 && setData(res.result);
      });
    }
    return () => {};
  }, [member, freezeDtls]);

  // console.log("data: ", data);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value && data) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 200) {
            if (setTblData && res.result) {
              setTblData
                ? setTblData((x) => [
                    ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                  ])
                : setTblData((x) => [res.result, ...x]);
            } else if (setMembers && res.result && res.result.status === 2) {
              setMembers((x) => [
                ...x.map((j) =>
                  j.id === res.result.memberId
                    ? {
                        ...j,
                        accStatus: 1,
                        invs: res.result.inv
                          ? j.invs.map((x) =>
                              x.id === res.result.inv.id ? res.result.inv : x
                            )
                          : j.invs,
                      }
                    : j
                ),
              ]);
            }
            setAlert({
              isOpen: true,
              type: "success",
              title: t("Success"),
              subTitle: res.msg,
            });
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("Error"),
              subTitle: res.msg,
            });
          setShowForm(false);
        }
      };

      API(endpoints.Freeze + actions.Unfreeze).post(
        ToFormData({ unfreezeDate: value, freezeId: data.id }),
        onComplete
      );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };
  const handleInpDate = (date) => {
    setValue(date);
    date && setError();
  };
  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper
          className="p-15"
          sx={{ maxWidth: "450px", backgroundColor: "var(--aliceblue-color)" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} className="tx-center p-20 mb-10 w-100pr">
              <h2 className="h fw-4 mb-5 tx-upp gray-color">
                {t("UnfreezeMember")}
              </h2>
              <div className="pos-relative d-flex j-center">
                <div className="border-bottom w-60" />
              </div>
            </Grid>
            <Grid item xs={12} className="mb-30">
              <InputDate
                label={t("UnfreezeDate")}
                name="date"
                required={true}
                value={new Date(value)}
                error={error}
                minDate={new Date()}
                onChange={(date) =>
                  handleInpDate(new Date(date).toLocaleDateString())
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Button
                variant="text"
                size="large"
                onClick={handleClose}
                fullWidth
              >
                {t("Cancel")}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button loading={loading} size="large" type="submit" fullWidth>
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default UnfreezeForm;
